import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Services from './components/Services';
import Approach from './components/Approach';
import Results from './components/Results';
import About from './components/About';
import CTA from './components/CTA';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-amber-50">
      <Navigation />
      <Hero />
      <Services />
      <Approach />
      <Results />
      <About />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}
